import * as urls from "@/recourses/urls/checkout";
import http from "@/utils/http";
import { snakeToCamelCase } from "@/utils/caseConverters";
import { reconcileCurrentStore } from "@/utils/storeCoverage";
import type { QuickStartResponse, IGetAvailableProductsResponse } from "./type";

export const getCartAvailableProducts = async (
  storeId: number,
  productsId: string
): Promise<IGetAvailableProductsResponse | undefined> => {
  try {
    const response = await http.get<IGetAvailableProductsResponse>(urls.availableProducts(storeId, productsId), {
      isAuth: true,
    });
    const data = response.data;

    // Handled once here for every consumer of this endpoint
    if (data?.store_changed && data.current_store) {
      reconcileCurrentStore(data.current_store, { requestedStoreId: storeId });
    }

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getShippingInfo = async (
  storeId: string | number,
  lat: number,
  lng: number,
  is_imported: boolean
): Promise<AvailableServiceAttr[] | undefined> => {
  const response = await http.get(urls.shippingInfo(storeId, lat, lng, is_imported), {
    isAuth: true,
  });
  return response.data;
};

export const getQuickStart = async (): Promise<QuickStartResponse | undefined> => {
  const response = await http.get(urls.quickStart, {
    isAuth: true,
  });
  return snakeToCamelCase(response.data) as QuickStartResponse;
};
